import {
    SET_ACTIVE_ASSET_COST_CENTER_DROP_DOWN,
    SET_ACTIVE_ASSET_MAKE_DROP_DOWN,
    SET_ACTIVE_ASSET_MODEL_DROP_DOWN,
    SET_ACTIVE_ASSET_YEAR_DROP_DOWN,
    SET_ACTIVE_ASSET_GL_CATEGORY_DROP_DOWN,
    SET_ACTIVE_ASSET_EQ_CLASS_CODE_DROP_DOWN,
    SET_ACTIVE_ASSET_STATE_DROP_DOWN,
    SET_ACTIVE_ASSET_ASSET_CATEGORY_DROP_DOWN
} from "./ActiveAssetDropDownType";

const initialState = {
    activeAssetCostCenterDropDown: null,
    activeAssetMakeDropDown: null,
    activeAssetModelDropDown: null,
    activeAssetYearDropDown: null,
    activeAssetGLCategoryDropDown: null,
    activeAssetAssetCategoryDropDown: null,
    activeAssetEqClassCodeDropDown: null,
    activeAssetStateDropDown: null
}

const reducers = (state = initialState, action: any) => {
    switch (action.type) {
        case SET_ACTIVE_ASSET_COST_CENTER_DROP_DOWN:
            return {
                ...state,
                activeAssetCostCenterDropDown: action.activeAssetCostCenterDropDown,
            };
        case SET_ACTIVE_ASSET_MAKE_DROP_DOWN:
            return {
                ...state,
                activeAssetMakeDropDown: action.activeAssetMakeDropDown,
            };
        case SET_ACTIVE_ASSET_MODEL_DROP_DOWN:
            return {
                ...state,
                activeAssetModelDropDown: action.activeAssetModelDropDown,
            };
        case SET_ACTIVE_ASSET_YEAR_DROP_DOWN:
            return {
                ...state,
                activeAssetYearDropDown: action.activeAssetYearDropDown,
            };
        case SET_ACTIVE_ASSET_GL_CATEGORY_DROP_DOWN:
            return {
                ...state,
                activeAssetGLCategoryDropDown: action.activeAssetGLCategoryDropDown,
            };
        case SET_ACTIVE_ASSET_ASSET_CATEGORY_DROP_DOWN:
            return {
                ...state,
                activeAssetAssetCategoryDropDown: action.activeAssetAssetCategoryDropDown,
            };
        case SET_ACTIVE_ASSET_EQ_CLASS_CODE_DROP_DOWN:
            return {
                ...state,
                activeAssetEqClassCodeDropDown: action.activeAssetEqClassCodeDropDown,
            };
        case SET_ACTIVE_ASSET_STATE_DROP_DOWN:
            return {
                ...state,
                activeAssetStateDropDown: action.activeAssetStateDropDown,
            };
        default:
            return state;
    }
}

export default reducers